/* eslint-disable import/prefer-default-export -- named export re-exported from list barrel */
import { RESERVATION_TAB_KEYS } from "./reservationTabConfig";

export const getReservationStatusBadge = (reservation, tabKey, t) => {
    if (tabKey === RESERVATION_TAB_KEYS.UPCOMING) {
        return { label: t("upcoming"), className: "bg-gray-100 text-gray-600" };
    }
    if (tabKey === RESERVATION_TAB_KEYS.ONGOING) {
        return { label: t("ongoing"), className: "bg-emerald-100 text-emerald-700" };
    }
    if (tabKey === RESERVATION_TAB_KEYS.PAST) {
        return { label: t("completed"), className: "bg-blue-100 text-blue-700" };
    }
    if (tabKey === RESERVATION_TAB_KEYS.REJECTED) {
        return { label: t("rejected"), className: "bg-red-100 text-red-700" };
    }
    if (tabKey === RESERVATION_TAB_KEYS.CANCELLED) {
        return { label: t("cancelled"), className: "bg-red-100 text-red-700" };
    }

    if (
        reservation.isApproved &&
        !reservation.isCarPickedUp &&
        !reservation.isRejected &&
        !reservation.isCancelled
    ) {
        return { label: t("upcoming"), className: "bg-gray-100 text-gray-600" };
    }
    if (
        reservation.isApproved &&
        reservation.isCarPickedUp &&
        !reservation.isCarDroppedOff &&
        !reservation.isRejected &&
        !reservation.isCancelled
    ) {
        return { label: t("ongoing"), className: "bg-emerald-100 text-emerald-700" };
    }
    if (
        reservation.isApproved &&
        reservation.isCarPickedUp &&
        reservation.isCarDroppedOff &&
        !reservation.isRejected &&
        !reservation.isCancelled
    ) {
        return { label: t("completed"), className: "bg-blue-100 text-blue-700" };
    }
    if (reservation.isRejected) {
        return { label: t("rejected"), className: "bg-red-100 text-red-700" };
    }
    if (reservation.isCancelled) {
        return { label: t("cancelled"), className: "bg-red-100 text-red-700" };
    }

    return { label: t("upcoming"), className: "bg-gray-100 text-gray-600" };
};
